import { Check } from "lucide-react";
import { PRICING, FAQ } from "../data/site";
import { Reveal, Label, BookButton, BOOKING_URL, INTERESTED_URL } from "../components/ui-kit";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function Pricing() {
  return (
    <>
      <section className="pt-40 pb-16 bg-black text-center" data-testid="pricing-hero">
        <div className="max-w-3xl mx-auto px-6">
          <Label className="justify-center">Pricing</Label>
          <h1 className="font-display uppercase text-white text-5xl md:text-8xl leading-[0.9] mt-6">Simple. Honest.</h1>
          <p className="mt-6 text-lg text-lightgrey">No confusing contracts or hidden fees. Just clear options — and a free intro to help you choose.</p>
        </div>
      </section>

      <section className="bg-black pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
          {PRICING.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.07}>
              <div className={`relative h-full rounded-3xl p-8 border flex flex-col ${p.featured ? "border-gold bg-gradient-to-b from-gold/15 to-transparent" : "border-white/10 bg-charcoal"}`} data-testid={`price-${p.name.toLowerCase().replace(/ /g, "-")}`}>
                {p.featured && <span className="absolute -top-3 left-8 text-xs font-bold uppercase tracking-wide bg-gold text-black px-3 py-1 rounded-full">Most Popular</span>}
                <h3 className="font-display text-2xl text-white uppercase">{p.name}</h3>
                <p className="text-sm text-lightgrey/70 mt-1 min-h-[40px]">{p.desc}</p>
                <div className="mt-4 flex items-end gap-1">
                  <span className="font-display text-5xl text-gold">{p.price}</span>
                  <span className="text-white/50 text-sm mb-2">/ {p.per}</span>
                </div>
                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex gap-2 text-sm text-lightgrey"><Check size={16} className="text-gold shrink-0 mt-0.5" />{f}</li>
                  ))}
                </ul>
                <div className="mt-8">
                  <a
                    href={p.url || BOOKING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`price-book-${i}`}
                    className={`w-full inline-flex items-center justify-center rounded-full font-bold px-8 py-4 transition-colors duration-300 ${p.featured ? "bg-gold text-black hover:bg-white" : "bg-transparent border border-gold text-gold hover:bg-gold hover:text-black"}`}
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-charcoal py-24" data-testid="faq">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal className="text-center mb-12">
            <Label className="justify-center">FAQ</Label>
            <h2 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-none">Good questions.</h2>
          </Reveal>
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border border-white/10 rounded-2xl bg-black/40 px-6" data-testid={`faq-${i}`}>
                <AccordionTrigger className="text-left text-white font-display text-lg uppercase hover:text-gold hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-lightgrey text-base">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section className="bg-black py-24 text-center" data-testid="pricing-cta">
        <div className="max-w-2xl mx-auto px-6">
          <Reveal>
            <Label className="justify-center">Start Today</Label>
            <h2 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-none">Your first visit<br />is on us.</h2>
            <p className="mt-5 text-lightgrey text-lg">Still have questions about pricing or which option fits? Book a free, no-pressure intro and we'll help you find the right plan.</p>
            <div className="mt-9 flex justify-center"><BookButton href={INTERESTED_URL} testid="pricing-book">Book a Free Intro</BookButton></div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
